import { auth } from "./firebase";

const DEV_FALLBACK_API_ROOT = "http://127.0.0.1:8787/api/quizpopz";

export const QUIZPOPZ_PROVIDERS = [
  {
    id: "openai",
    label: "GPT 5.5",
    modelName: "gpt-5.5",
    accent: "sunrise",
    description: "Balanced reasoning, clean structure, and strong explanation quality.",
  },
  {
    id: "anthropic",
    label: "Claude Opus 4.7",
    modelName: "claude-opus-4-7",
    accent: "coral",
    description: "Long-form instruction following with polished distractors and nuance.",
  },
  {
    id: "google",
    label: "Gemini 3 PRO",
    modelName: "gemini-3-pro",
    accent: "lagoon",
    description: "Fast structured output with broad coverage across school topics.",
  },
];

function defaultApiUrl(path) {
  const explicit = process.env.REACT_APP_QUIZPOPZ_API_URL;
  if (explicit) {
    const cleaned = explicit.replace(/\/$/, "");
    if (/\/(generate|flashcards)$/.test(cleaned)) {
      return cleaned.replace(/\/(generate|flashcards)$/, `/${path}`);
    }
    return `${cleaned}/${path}`;
  }
  if (typeof window !== "undefined") {
    const isLocalHost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
    if (isLocalHost) return `${DEV_FALLBACK_API_ROOT}/${path}`;
  }
  return `/api/quizpopz/${path}`;
}

async function postQuizPopz(path, payload, fallbackMessage) {
  const headers = {
    "Content-Type": "application/json",
  };

  const user = auth.currentUser;
  if (user) {
    const idToken = await user.getIdToken();
    headers.Authorization = `Bearer ${idToken}`;
  }

  const response = await fetch(defaultApiUrl(path), {
    method: "POST",
    headers,
    body: JSON.stringify(payload),
  });

  let data = null;
  try {
    data = await response.json();
  } catch (_) {
    data = null;
  }

  if (!response.ok) {
    const message = data && data.error ? data.error : fallbackMessage;
    const err = new Error(message);
    err.details = data;
    throw err;
  }

  return data;
}

export async function generateQuizPopzQuiz(payload) {
  return postQuizPopz("generate", payload, "Quiz generation failed.");
}

export async function generateQuizPopzFlashcards(payload) {
  return postQuizPopz("flashcards", payload, "Flashcard generation failed.");
}

export async function getQuizPopzCredits() {
  return postQuizPopz("credits", {}, "Could not load AI credits.");
}